export const Types = {
    OPEN_EXPORT_REPORT_MODAL: "OPEN_EXPORT_REPORT_MODAL",
    EXPORT_REPORT: "EXPORT_REPORT",
    CLEAR_EXPORT_REPORT_STATES: "CLEAR_EXPORT_REPORT_STATES"
  };